import axios from 'axios'
import { defineTipoLink, formatLinkWithDate } from '../../../Utils/Utils'

global.cameraPrincipal = null
global.timerDGuard = null
global.timerSigma = null
global.atualizarCamera = null
global.fila = []
global.tipoLink = 'interno'
global.sessaoCamera = null
global.timerSessaoCamera = null
global.codigoCameraAtual = null
global.servidores = {}

async function convert2DataUrl(blobOrFile) {
    const reader = new FileReader()
    reader.readAsDataURL(blobOrFile)
    await new Promise((resolve) => { reader.onload = () => { resolve() } })
    return reader.result
}

export const setCameras = (cameras) => {
    if (!cameras) {
        zerarTimerSigma()
        zerarTimerDGuard()
        global.cameraPrincipal = null
        global.fila = []
        return
    }

    if (!global.cameraPrincipal || (cameras[0].id !== global.cameraPrincipal.id)) {
        global.fila = []
    }

    setCameraPrincipal(cameras[0])
    iniciarTimerCamera()
}

export const setCameraPrincipal = (camera) => {
    camera.link = defineTipoLink(global.tipoLink, camera.linkInterno, camera.linkExterno)
    global.cameraPrincipal = camera
    global.codigoCameraAtual = camera.id
}

export const iniciarFila = async (camera) => {
    if (global.sessaoCamera == null) {
        const { linkInterno, linkExterno, token } = camera
        const link = defineTipoLink(global.tipoLink, linkInterno, linkExterno)
        await requisicaoDguard(link, token)
        setTimeout(() => {
            iniciarFila(camera)
        }, 300)
        return
    }
    global.fila.push(camera)

    if (global.fila.length > 1) {
        return
    }

    const initLoading = async () => {
        let cameraAux

        if (global.fila.length == 0) {
            return
        }

        cameraAux = global.fila[0]
        global.fila.shift()

        const { linkInterno, linkExterno, token } = cameraAux.camera
        const link = defineTipoLink(global.tipoLink, linkInterno, linkExterno)

        if (token) {
            try {
                const response = await requisicaoDguard(link, token)
                const imageLink = await convert2DataUrl(response.data)
                cameraAux.setCameraTemplate(false)
                cameraAux.setLinkAux(imageLink)
            } catch (error) {
                cameraAux.setCameraTemplate('error')
                console.log('Erro ao requisitar camera: ', error.message)
            }
        }
    }

    initLoading()
}

export const setAtualizarCamera = (funcoes) => {
    global.atualizarCamera = funcoes
}

export const iniciarTimerCamera = () => {
    if (!global.cameraPrincipal) {
        return
    }

    if (global.cameraPrincipal?.token) {
        if (!global.timerDGuard) {
            global.timerDGuard = true
            getCameraDGuard()
        }
        zerarTimerSigma()
    } else {
        if (!global.timerSigma) {
            global.timerSigma = setInterval(() => {
                getCameraSigma()
            }, 300)
        }
        zerarTimerDGuard()
    }
}

const getCameraSigma = () => {
    // if (!global.janelaAtiva) return
    global.atualizarCamera.setLinkAux(formatLinkWithDate(global.cameraPrincipal.link))
    global.atualizarCamera.setCameraTemplate(false)
}

const getCameraDGuard = async () => {
    if (!global.cameraPrincipal || !global.cameraPrincipal?.token || !global.timerDGuard) {
        return
    }

    try {
        const idCameraRequisicao = global.cameraPrincipal.id
        const response = await requisicaoDguard(global.cameraPrincipal.link, global.cameraPrincipal.token)

        if (response) {
            if (idCameraRequisicao !== global.codigoCameraAtual) {
                return
            }

            const imageLink = await convert2DataUrl(response.data)

            if (global.atualizarCamera) {
                global.atualizarCamera.setLinkAux(imageLink)
                global.atualizarCamera.setCameraTemplate(false)
            }
        }
        setTimeout(() => {
            getCameraDGuard()
        }, 300)
    } catch (error) {
        global.atualizarCamera.setCameraTemplate('error')
        setTimeout(() => {
            getCameraDGuard()
        }, 1000)
    }
}

export const requisicaoDguard = async (link, token) => {
    if (!link) return false
    // http://192.168.30.138:90/camera.cgi?receiver=1&server=0093&resolucao=400x300&qualidade=50&formato=jpg&ds=11325742&canrepeatimage=true&camera=23
    // salvar o link do servidor para verificar se é o mesmo
    let linkAux = link.split('camera.cgi')[0]
    linkAux = linkAux.replaceAll('http://', '')
    linkAux = linkAux.replaceAll(':', '')
    linkAux = linkAux.replaceAll('/', '')
    linkAux = linkAux.replaceAll('.', '')
    linkAux = linkAux.replaceAll(' ', '')

    if (!global.servidores[linkAux]) {
        global.servidores[linkAux] = {}
    } else {
        if (global.servidores[linkAux].sessionId && (new Date().getTime() - global.servidores[linkAux].time) < 45000) {
            global.sessaoCamera = global.servidores[linkAux].sessionId
        } else {
            global.servidores[linkAux] = {}
            global.sessaoCamera = null
        }
    }

    // if (!global.janelaAtiva) return false
    if (global.timerSessaoCamera) {
        clearTimeout(global.timerSessaoCamera)
        global.timerSessaoCamera = null
    }
    let headers = {
        SameSite: 'none'
    }
    if (global.sessaoCamera) {
        headers.SessaoId = global.sessaoCamera
    } else {
        headers.Authorization = `Basic ${token}`
    }
    return await axios.get(link, {
        headers,
        responseType: 'blob',
        timeout: 4500
    }).then((response) => {
        global.sessaoCamera = response.headers.sessaoid
        global.servidores[linkAux].sessionId = response.headers.sessaoid
        global.servidores[linkAux].time = new Date().getTime()
        global.timerSessaoCamera = setTimeout(() => {
            global.sessaoCamera = null
        }, 45000)
        return response
    }).catch((error) => {
        if (error.response?.status === 401) {
            global.sessaoCamera = null
            global.servidores[linkAux] = {}
        }
        return error
    })
}

const zerarTimerDGuard = () => {
    if (global.timerDGuard) {
        global.timerDGuard = null
    }
}

const zerarTimerSigma = () => {
    if (global.timerSigma) {
        clearInterval(global.timerSigma)
        global.timerSigma = null
    }
}

export const pausarTimerCamera = () => {
    zerarTimerDGuard()
    zerarTimerSigma()
}
